const styles = {
  rootRow: {
    position: 'relative',
    paddingX: '0px!important',
  },

  rootColumn: {
    padding: 1,
    paddingRight: { xs: 4, md: 1 },
    paddingLeft: { xs: 4, md: 1 },
  },

  bodyTypeColumn: {
    backgroundColor: 'common.white',
    marginTop: '-100px',
    boxShadow: 1,
    '& a': {
      width: '100%',
    },
  },

  bodyTypesPaddingRow: {
    padding: 0,
    paddingX: '0px!important',
    borderRadius: 0.5,
  },

  bodyTypesPaddingColumn: {
    marginBottom: { xs: 2 },
    padding: { xs: 2, sm: 4 },
    borderRadius: { xs: 8 },
  },

  bodyType: {
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '&:nth-of-type(2n)': {
      alignItems: { xs: 'flex-end', md: 'unset' },
    },
    '&:nth-of-type(2n+1)': {
      alignItems: { xs: 'flex-start', md: 'unset' },
    },
  },

  featuresTitle: {
    marginBottom: 6,
  },

  link: {
    textDecoration: 'none',
    textAlign: 'center',
    width: '100%',
  },

  lastLink: {
    textDecoration: 'none',
    '& .MuiTypography-body2': {
      textAlign: 'center',
    },
  },

  tileItem: {
    backgroundColor: 'background.default',
    border: 1,
    borderColor: '#E9E9E9',
    borderRadius: 50,
    '& .Tile-icon': {
      width: 50,
      paddingLeft: 1,
      paddingRight: 0.5,
      paddingY: 0,
    },
    '& .Tile-text': {
      fontSize: '12px!important',
      color: (theme) => `${theme.palette.text.primaryDark}!important`,
      paddingLeft: '0px',
    },
    '&.see-more': {
      paddingLeft: '8px!important',
    },
  },

  linksContainer: {
    marginTop: 3,
    '&.row': {
      marginTop: 0,
      paddingLeft: 0,
      position: 'relative',
      flexWrap: { xs: 'initial' },
      overflow: { xs: 'auto' },
      '&::-webkit-scrollbar': {
        flexWrap: { xs: 'initial' },
        overflow: { xs: 'auto' },
      },
    },
  },

  btnRight: {
    display: { xs: 'block' },
    position: 'absolute',
    right: -15,
    bottom: 22,
    width: 25,
    height: 25,
    minWidth: 'auto',
    backgroundColor: (theme) => `${theme.palette.background.grey600}!important`,
    padding: 0,
    border: '2px solid #fff',
    color: 'primary.main',
    borderRadius: 6,
    '& svg': {
      width: 7,
    },
  },

  bodyTypesTitle: {
    marginBottom: 1,
  },

  btnLeft: {
    display: { xs: 'block' },
    position: 'absolute',
    left: -15,
    bottom: 22,
    width: 25,
    height: 25,
    minWidth: 'auto',
    borderRadius: 6,
    backgroundColor: (theme) => `${theme.palette.background.grey600}!important`,
    padding: 0,
    border: '2px solid #fff',
    color: 'primary.main',
    '& svg': {
      width: 6,
    },
  },
}

export default styles
